import React, { useState, useEffect } from "react";
import {
  Dialog,
  DialogContent,
  DialogTitle,
  DialogActions,
  Button,
  TextField,
  TextFieldProps,
  Grid,
  IconButton,
  Typography,
  Box,
  Paper,
  MenuItem,
} from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import DeleteIcon from "@mui/icons-material/Delete";
import { styled } from "@mui/material/styles";
interface CounselingDetail {
  견적경로: string;
  상담번호: number;
  상담구분: string;
  상담상태: string;
  조인업체명: string;
  담당자: string;
  담당자번호: number;
  담당자이메일: string;
  담당자전화: string;
  판매업체: string;
  판매업체번호: number;
  수배처: string | null;
  수배처번호: number | null;
  요청자명: string;
  요청자휴대폰: string;
  요청자이메일: string;
  일정표주소: string;
  시작일: string;
  종료일: string;
  견적명: string;
  견적내용: string;
  성인수: number;
  소아수: number;
  유아수: number;
  성인판매가: number;
  소아판매가: number;
  유아판매가: number;
  원가구분: string;
  통화코드: string;
  통화기호: string;
  성인원가: number;
  소아원가: number;
  유아원가: number;
  고객명단: string;
  인솔자수: number;
  입금총액: number;
  출금총액: number;
  총예상수익: number;
  총원가: CostDetail[];
  입출금: PaymentRecord[];
  총수익: number;
  첨부파일?: string[];
  판매총액: number;
  원가총액: number;
}
interface CostDetail {
  원가항목: string;
  통화기호: string;
  통화코드: string;
  환율적용방식: string;
  환율적용방식코드: string;
  적용환율: number;
  성인: number;
  어린이: number;
  영유아: number;
  공용원가여부: boolean;
  업체번호: number;
}

interface PaymentRecord {
  입출금번호: number;
  일시: string;
  구분: "입금" | "출금" | "환불" | "환입";
  입출대상: string;
  내역: string;
  금액: number;
}

interface CostManageDialogProps {
  open: boolean;
  onClose: () => void;
  onSave: (personalCosts: CostDetail[], sharedCosts: CostDetail[]) => void;
  initialPersonalCosts?: CostDetail[];
  initialSharedCosts?: CostDetail[];
  counselingDetail: CounselingDetail | null;
  setCounselingDetail: (detail: CounselingDetail) => void;
  setIsDataModified: (modified: boolean) => void;
  isOtherCompanyData?: boolean;
  companyNo?: string | null;
}

const StyledPaper = styled(Paper)`
  transition: box-shadow 0.1s ease-in-out;
  border: 1px solid #ddd;
  border-radius: 6px;
  background-color: #fff;
  box-shadow: 2px 2px 4px rgba(0, 0, 0, 0.1);
  &:hover {
    outline: 0.5px solid #1976d2;
  }
`;

const BaseStyledTextField = styled(TextField)`
  width: 100%;

  & .MuiOutlinedInput-root {
    height: 32px;
    font-size: 14px;
    background-color: #fff;

    &:hover fieldset {
      border-color: #1976d2;
    }

    &.Mui-focused fieldset {
      border-color: #1976d2;
    }

    &.Mui-disabled {
      background-color: #f5f5f5;
    }

    & input {
      text-align: left;
    }
  }

  & .MuiOutlinedInput-input {
    padding: 4px 8px;
    text-align: left;
  }

  &.right-align .MuiOutlinedInput-input {
    text-align: right;
  }
` as typeof TextField;

const StyledTextField = React.forwardRef<HTMLDivElement, TextFieldProps>(
  (props, ref) => {
    return <BaseStyledTextField {...props} size="small" fullWidth ref={ref} />;
  }
);

const formatNumberWithCommas = (num: number): string => {
  return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
};

const CostManageDialog: React.FC<CostManageDialogProps> = ({
  open,
  onClose,
  onSave,
  initialPersonalCosts = [],
  initialSharedCosts = [],
  counselingDetail,
  setCounselingDetail,
  setIsDataModified,
  isOtherCompanyData,
  companyNo
}) => {
  const [personalCosts, setPersonalCosts] = useState<CostDetail[]>(initialPersonalCosts);
  const [sharedCosts, setSharedCosts] =    useState<CostDetail[]>(initialSharedCosts);

  // useEffect(() => {
  //   if (counselingDetail) {
     
  //   }
  // }, [counselingDetail]);

  const handleAddPersonalCost = () => {
    console.log('personalCosts', personalCosts)
    setPersonalCosts([
      ...personalCosts,
      {
        원가항목: "",
        통화기호: "₩",
        통화코드: "KRW",
        환율적용방식: "",
        환율적용방식코드: "",
        적용환율: 1,
        성인: 0,
        어린이: 0,
        영유아: 0,
        공용원가여부: false,
        업체번호: Number(localStorage.getItem('CompanyNo'))
      },
    ]);
    setIsDataModified(true);
  };

  const handleAddSharedCost = () => {
    setSharedCosts([
      ...sharedCosts,
      {
        원가항목: "",
        통화기호: "₩",
        통화코드: "KRW",
        환율적용방식: "",
        환율적용방식코드: "",
        적용환율: 1,
        성인: 0,
        어린이: 0,
        영유아: 0,
        공용원가여부: true,
        업체번호: Number(localStorage.getItem('CompanyNo'))
      },
    ]);
    setIsDataModified(true);
  };
  
  const handlePersonalCostChange = (
    index: number,
    field: keyof CostDetail,
    value: string
  ) => {
    const updatedCosts = [...personalCosts];
    const cost = { ...updatedCosts[index] };

    if (field === "통화코드") {
      cost.통화기호 = value === "KRW" ? "₩" : value === "USD" ? "$" : "¥";
      cost.적용환율 = value === "KRW" ? 1 : cost.적용환율;
      cost.통화코드 = value;
    } else if (
      field === "적용환율" ||
      field === "성인" ||
      field === "어린이" ||
      field === "영유아"
    ) {
      cost[field] = value === "" ? 0 : parseFloat(value.replace(/,/g, ""));
    } else if (field === "원가항목") {
      cost.원가항목 = value;
    }

    updatedCosts[index] = cost;
    setPersonalCosts(updatedCosts);
    setIsDataModified(true);
  };

  const handleSharedCostChange = (
    index: number,
    field: keyof CostDetail,
    value: string
  ) => {
    const updatedCosts = [...sharedCosts];
    const cost = { ...updatedCosts[index] };

    if (field === "통화코드") {
      cost.통화기호 = value === "KRW" ? "₩" : value === "USD" ? "$" : "¥";
      cost.적용환율 = value === "KRW" ? 1 : cost.적용환율;
      cost.통화코드 = value;
    } else if (field === "적용환율" || field === "성인") {
      cost[field] = value === "" ? 0 : parseFloat(value.replace(/,/g, ""));
    } else if (field === "원가항목") {
      cost.원가항목 = value;
    }

    updatedCosts[index] = cost;
    setSharedCosts(updatedCosts);
    setIsDataModified(true);
  };

  const handleDeletePersonalCost = (index: number) => {
    setPersonalCosts(personalCosts.filter((_, i) => i !== index));
    setIsDataModified(true);
  };

  const handleDeleteSharedCost = (index: number) => {
    setSharedCosts(sharedCosts.filter((_, i) => i !== index));
    setIsDataModified(true);
  };

  // 원가 계산 함수
  const calculateDetailCosts = (
    personalCosts: CostDetail[],
    sharedCosts: CostDetail[]
  ) => {
    if (!counselingDetail) return null;

    // 개인별 원가 계산
    const 개인성인원가 = personalCosts.reduce(
      (sum, cost) => sum + cost.성인 * cost.적용환율,
      0
    );
    const 개인소아원가 = personalCosts.reduce(
      (sum, cost) => sum + cost.어린이 * cost.적용환율,
      0
    );
    const 개인유아원가 = personalCosts.reduce(
      (sum, cost) => sum + cost.영유아 * cost.적용환율,
      0
    );

    // 공용 원가 계산 (인원수로 나누어 1인당 비용 계산)
    // const 총인원 = (counselingDetail.성인수 || 0) + (counselingDetail.소아수 || 0) + (counselingDetail.유아수 || 0);
    const 공용원가 = sharedCosts.reduce(
      (sum, cost) => sum + cost.성인 * cost.적용환율,
      0
    );

    const 공용1인원가 =
      counselingDetail.성인수 > 0
        ? 공용원가 / (counselingDetail.성인수 || 0)
        : 0;

    return {
      성인원가: Math.round(개인성인원가 + 공용1인원가),
      소아원가: Math.round(개인소아원가),
      유아원가: Math.round(개인유아원가),
    };
  };

  const handleSave = () => {
    if (!counselingDetail) return;

    // 원가 계산
    const calculatedCosts = calculateDetailCosts(personalCosts, sharedCosts);
    if (!calculatedCosts) return;

    // 원가총액 계산
    const 원가총액 =
      calculatedCosts.성인원가 * (counselingDetail.성인수 || 0) +
      calculatedCosts.소아원가 * (counselingDetail.소아수 || 0) +
      calculatedCosts.유아원가 * (counselingDetail.유아수 || 0);

    // 총예상수익 계산
    const 총예상수익 =
      (counselingDetail.성인판매가 - calculatedCosts.성인원가) *
        (counselingDetail.성인수 || 0) +
      (counselingDetail.소아판매가 - calculatedCosts.소아원가) *
        (counselingDetail.소아수 || 0) +
      (counselingDetail.유아판매가 - calculatedCosts.유아원가) *
        (counselingDetail.유아수 || 0);

    // 부모 컴포넌트로 전달할 데이터 준비
    // onSave(personalCosts, sharedCosts);

    // 부모 컴포넌트의 상태 업데이트
    const updatedDetail = {
      ...counselingDetail,
      총원가: [...personalCosts, ...sharedCosts],
      성인원가: calculatedCosts.성인원가,
      소아원가: calculatedCosts.소아원가,
      유아원가: calculatedCosts.유아원가,
      원가총액,
      총예상수익,
    };

    setCounselingDetail(updatedDetail);
    setIsDataModified(true);
    onSave(personalCosts, sharedCosts);
    onClose();
  };

  // 원화환산 1인평균값 계산
  const calculateAverageCosts = () => {
    const 성인총원가 = personalCosts.reduce(
      (sum, cost) => sum + cost.성인 * cost.적용환율,
      0
    );
    const 소아총원가 = personalCosts.reduce(
      (sum, cost) => sum + cost.어린이 * cost.적용환율,
      0
    );
    const 유아총원가 = personalCosts.reduce(
      (sum, cost) => sum + cost.영유아 * cost.적용환율,
      0
    );

    return {
      성인평균: Math.round(성인총원가) || 0,
      소아평균: Math.round(소아총원가) || 0,
      유아평균: Math.round(유아총원가) || 0,
    };
  };

  // const averageCosts = calculateAverageCosts();
  const averageCosts = calculateDetailCosts(personalCosts, sharedCosts) || {
    성인원가: 0,
    소아원가: 0,
    유아원가: 0,
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      
      maxWidth="lg"
      fullWidth
      PaperProps={{
          sx: {
              borderRadius: '12px',
              maxHeight: '90vh',
              width: '1000px'
          }
      }}
    >
      <Box sx={{ width: "100%", p: 0, minHeight: "550px", maxHeight: "900px" }}>
        <DialogTitle
          sx={{
            bgcolor: "primary.main",
            color: "white",
            display: "flex",
            alignItems: "center",
            p: 3,
            margin: -0,
            marginBottom: 0,
            height: "64px",
          }}
        >
          <Typography variant="h6" sx={{ flex: 1, fontSize: "1rem" }}>
            세부 원가 설정
          </Typography>
          <DialogActions
            sx={{
              p: 0,
              borderTop: 1,
              borderColor: "divider",
            }}
          >
            <Button
              variant="contained"
              onClick={handleSave}
              sx={{ height: "32px", minWidth: "100px", bgcolor: "info.main" }}
            >
              적용
            </Button>
            <Button variant="contained" onClick={onClose} sx={{ height: "32px", minWidth: "100px", bgcolor: "grey.600" }}>취소</Button>
          </DialogActions>
        </DialogTitle>
        <DialogContent sx={{ p: 3 }}>
          <Box>
            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                mb: 2,
                mt: 2,
              }}
            >
              <Typography
                variant="subtitle1"
                sx={{
                  color: "primary.main",
                  fontWeight: "bold",
                }}
              >
                개인별 원가
              </Typography>
              
                <Button
                  variant="outlined"
                  size="small"
                  onClick={handleAddPersonalCost}
                  startIcon={<AddIcon />}
                  sx={{ height: "32px" }}
                >
                  추가
                </Button>
              
            </Box>
            <StyledPaper sx={{ p: 3, mb: 1.5  }}>
              <Grid container spacing={2} sx={{width: "100%" }}>
                <Grid item xs={4}>
                  <Typography variant="body2" color="text.secondary">
                    원가항목
                  </Typography>
                </Grid>
                <Grid item xs={1.5}>
                  <Typography variant="body2" color="text.secondary">
                    통화
                  </Typography>
                </Grid>
                <Grid item xs={1.5}>
                  <Typography variant="body2" color="text.secondary">
                    적용환율
                  </Typography>
                </Grid>
                <Grid item xs={1.5}>
                  <Typography variant="body2" color="text.secondary">
                    성인
                  </Typography>
                </Grid>
                <Grid item xs={1.5}>
                  <Typography variant="body2" color="text.secondary">
                    어린이
                  </Typography>
                </Grid>
                <Grid item xs={1.5}>
                  <Typography variant="body2" color="text.secondary">
                    영유아
                  </Typography>
                </Grid>
                
              </Grid>

              {personalCosts.map((cost, index) => (
                <Grid 
                    container 
                    spacing={2} 
                    key={index} 
                    sx={{ 
                        mb: 1,
                        opacity: cost.업체번호?.toString() !== companyNo ? 0.7 : 1,
                        
                    }}
                >
                  <Grid item xs={3.7}>
                    <StyledTextField
                      fullWidth
                      size="small"
                      value={cost.원가항목}
                      onChange={(e) => handlePersonalCostChange(index, "원가항목", e.target.value)}
                      disabled={cost.업체번호?.toString() !== companyNo}
                    />
                  </Grid>
                  <Grid item xs={1.5}>
                    <StyledTextField
                      select
                      fullWidth
                      size="small"
                      value={cost.통화코드}
                      onChange={(e) => handlePersonalCostChange(index, "통화코드", e.target.value)}
                      disabled={cost.업체번호?.toString() !== companyNo}
                    >
                      <MenuItem value="KRW">KRW</MenuItem>
                      <MenuItem value="USD">USD</MenuItem>
                      <MenuItem value="JPY">JPY</MenuItem>
                    </StyledTextField>
                  </Grid>
                  <Grid item xs={1.5}>
                    <StyledTextField
                      fullWidth
                      size="small"
                      value={formatNumberWithCommas(cost.적용환율)}
                      onChange={(e) => handlePersonalCostChange(index, "적용환율", e.target.value)}
                      disabled={cost.통화코드 === "KRW" || cost.업체번호?.toString() !== companyNo}
                      inputProps={{
                        style: { textAlign: "right" },
                      }}
                    />
                  </Grid>
                  <Grid item xs={1.5}>
                    <StyledTextField
                      fullWidth
                      size="small"
                      value={formatNumberWithCommas(cost.성인)}
                      onChange={(e) => handlePersonalCostChange(index, "성인", e.target.value)}
                      disabled={cost.업체번호?.toString() !== companyNo}
                      inputProps={{
                        style: { textAlign: "right" },
                      }}
                    />
                  </Grid>
                  <Grid item xs={1.5}>
                    <StyledTextField
                      fullWidth
                      size="small"
                      value={formatNumberWithCommas(cost.어린이)}
                      onChange={(e) => handlePersonalCostChange(index, "어린이", e.target.value)}
                      disabled={cost.업체번호?.toString() !== companyNo}
                      inputProps={{
                        style: { textAlign: "right" },
                      }}
                    />
                  </Grid>
                  <Grid item xs={1.5}>
                    <StyledTextField
                      fullWidth
                      size="small"
                      value={formatNumberWithCommas(cost.영유아)}
                      onChange={(e) => handlePersonalCostChange(index, "영유아", e.target.value)}
                      disabled={cost.업체번호?.toString() !== companyNo}
                      inputProps={{
                        style: { textAlign: "right" },
                      }}
                    />
                  </Grid>
                  <Grid
                    item
                    xs={0.8}
                    sx={{ display: "flex", alignItems: "center" }}
                  >
                    {cost.업체번호?.toString() === companyNo && (
                        <IconButton
                            size="small"
                            onClick={() => handleDeletePersonalCost(index)}
                            sx={{ color: 'error.main' }}
                        >
                            <DeleteIcon />
                        </IconButton>
                    )}
                  </Grid>
                </Grid>
              ))}
            </StyledPaper>
          </Box>

          <Box>
            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                mb: 2,
                mt: 2,
              }}
            >
              <Typography
                variant="subtitle1"
                sx={{
                  color: "primary.main",
                  fontWeight: "bold",
                }}
              >
                공용 원가
              </Typography>
              <Button
                variant="outlined"
                size="small"
                onClick={handleAddSharedCost}
                startIcon={<AddIcon />}
                sx={{ height: "32px" }}
              >
                추가
              </Button>
            </Box>
            <StyledPaper sx={{ p: 3, mb: 1.5 }}>
              <Grid container spacing={2} >
                <Grid item xs={5.3}>
                  <Typography variant="body2" color="text.secondary">
                    원가항목
                  </Typography>
                </Grid>
                <Grid item xs={1.5}>
                  <Typography variant="body2" color="text.secondary">
                    통화
                  </Typography>
                </Grid>
                <Grid item xs={1.5}>
                  <Typography variant="body2" color="text.secondary">
                    적용환율
                  </Typography>
                </Grid>
                <Grid item xs={2}>
                  <Typography variant="body2" color="text.secondary">
                    금액
                  </Typography>
                </Grid>
                
              </Grid>
              {sharedCosts.map((cost, index) => (
                <Grid 
                    container 
                    spacing={2} 
                    key={index} 
                    sx={{ 
                        mb: 1,
                        opacity: cost.업체번호?.toString() !== companyNo ? 0.7 : 1
                    }}
                >
                  <Grid item xs={5.2}>
                    <StyledTextField
                      fullWidth
                      size="small"
                      value={cost.원가항목}
                      onChange={(e) => handleSharedCostChange(index, "원가항목", e.target.value)}
                      disabled={cost.업체번호?.toString() !== companyNo}
                    />
                  </Grid>
                  <Grid item xs={1.5}>
                    <StyledTextField
                      select
                      fullWidth
                      size="small"
                      value={cost.통화코드}
                      onChange={(e) => handleSharedCostChange(index, "통화코드", e.target.value)}
                      disabled={cost.업체번호?.toString() !== companyNo}
                    >
                      <MenuItem value="KRW">KRW</MenuItem>
                      <MenuItem value="USD">USD</MenuItem>
                      <MenuItem value="JPY">JPY</MenuItem>
                    </StyledTextField>
                  </Grid>
                  <Grid item xs={1.5}>
                    <StyledTextField
                      fullWidth
                      size="small"
                      value={formatNumberWithCommas(cost.적용환율)}
                      onChange={(e) => handleSharedCostChange(index, "적용환율", e.target.value)}
                      disabled={cost.통화코드 === "KRW" || cost.업체번호?.toString() !== companyNo}
                      inputProps={{
                        style: { textAlign: "right" },
                      }}
                    />
                  </Grid>
                  <Grid item xs={3}>
                    <StyledTextField
                      fullWidth
                      size="small"
                      value={formatNumberWithCommas(cost.성인)}
                      onChange={(e) => handleSharedCostChange(index, "성인", e.target.value)}
                      disabled={cost.업체번호?.toString() !== companyNo}
                      inputProps={{
                        style: { textAlign: "right" },
                      }}
                    />
                  </Grid>
                  <Grid
                    item
                    xs={0.8}
                    sx={{ display: "flex", alignItems: "center" }}
                  >
                    {cost.업체번호?.toString() === companyNo && (
                        <IconButton
                            size="small"
                            onClick={() => handleDeleteSharedCost(index)}
                            sx={{ color: 'error.main' }}
                        >
                            <DeleteIcon />
                        </IconButton>
                    )}
                  </Grid>
                </Grid>
              ))}
            </StyledPaper>
          </Box>
          <StyledPaper sx={{ px: 3, pb: 1 , mt: 2 }}>
            <Grid
              container
              sx={{ bgcolor: "#f5f5f5", borderRadius: 1, mt: 1, p: 1, pr: 4 }}
            >
              <Grid item xs={3}>
                <Typography variant="body2" color="text.secondary">
                  원화환산 1인 원가
                </Typography>
              </Grid>
              <Grid item xs={1.5}></Grid>

              <Grid item xs={2}>
                <Typography variant="body2" align="right">
                  성인 : {formatNumberWithCommas(averageCosts?.성인원가 || 0)}{" "}
                  원
                </Typography>
              </Grid>
              <Grid item xs={2}>
                <Typography variant="body2" align="right">
                  소아 : {formatNumberWithCommas(averageCosts?.소아원가 || 0)}{" "}
                  원
                </Typography>
              </Grid>
              <Grid item xs={2}>
                <Typography variant="body2" align="right">
                  유아 : {formatNumberWithCommas(averageCosts?.유아원가 || 0)}{" "}
                  원
                </Typography>
              </Grid>
              <Grid item xs={0.35}></Grid>
            </Grid>
          </StyledPaper>
        </DialogContent>
      </Box>
    </Dialog>
  );
};

export default CostManageDialog;
